/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const XMarkSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.41854 3.41854C3.6016 3.23549 3.8984 3.23549 4.08146 3.41854L7.5 6.83709L10.9185 3.41854C11.1016 3.23549 11.3984 3.23549 11.5815 3.41854C11.7645 3.6016 11.7645 3.8984 11.5815 4.08146L8.16291 7.5L11.5815 10.9185C11.7645 11.1016 11.7645 11.3984 11.5815 11.5815C11.3984 11.7645 11.1016 11.7645 10.9185 11.5815L7.5 8.16291L4.08146 11.5815C3.8984 11.7645 3.6016 11.7645 3.41854 11.5815C3.23549 11.3984 3.23549 11.1016 3.41854 10.9185L6.83709 7.5L3.41854 4.08146C3.23549 3.8984 3.23549 3.6016 3.41854 3.41854Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default XMarkSvg
